import { LABEL_ERRORS, STATUS_CODES } from 'apollo/serverErrors';

function useError(error) {
  if (error?.networkError?.statusCode === STATUS_CODES.BAD_REQUEST) {
    return LABEL_ERRORS.USER_INPUT_MESSAGE;
  }
  return LABEL_ERRORS.UNKNOW_ERROR_MESSAGE;
}
export default useError;
